'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './custom-show.routes';
var pluralize = require('pluralize');

export class CustomShowComponent {
  constructor($stateParams, VendorService, $uibModal, $window, RecentVisits, PinnedItems, CustomEntityService,
              SettingsService, PropertyService, $timeout) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.entityId = $stateParams.id;
    this.type = $stateParams.type;
    this.dehyphendType = this.type.replace(/-/g," ");
    this.$uibModal = $uibModal;

    this.tasks = [];
    this.activities = [];
    this.custom = {};

    this.CustomEntityService = CustomEntityService;
    this.SettingsService = SettingsService;
    this.RecentVisits = RecentVisits;
    this.PinnedItems = PinnedItems;

    this.PropertyService = PropertyService;
    this.$timeout = $timeout;

    this.SettingsService.getByName({name: 'custom-entities'}, settings => {
      this.view = settings.data.entityView[this.type];
    });

    this.SettingsService.getByName({name: 'custom-entities-views'}, settings => {
      this.customEntitiesConfig = settings.data["entity:" + this.type] || {display:[]};
      this.customEntitiesConfig.display.forEach(customType => {
        let typeConfig = this.customEntitiesConfig[customType];
        this.custom[customType] = CustomEntityService.getCustomList({type: customType, refField: typeConfig.refField, refId: $stateParams.id});
      });
    });

    const REGEX_ALL = /([^\W_]+[^\s-]*) */g;
    const REGEX_FIRST = /([^\W_]+[^\s-]*)/;

    this.capitalize = (input, all) => {
      if (!input) return '';
      const regex = (all) ? REGEX_ALL : REGEX_FIRST;
      return input.replace(regex, (txt) =>
        txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    };

    this.refreshData();
  }

  openCustomEntityLetterWithContactSelect(entityId, entityName, propertyId, template, attach) {
    var that = this;

    let MAP_GROUP = {'primary-owner': "Primary Owner", 'owner': "Owner", 'renter': 'Renter', 'previous-owner': "Previous Owner", "vistor": "Visitor"};

    this.PropertyService.getContacts({id: propertyId}, contacts => {

      let pickContactPreselects = [];

      contacts.forEach(oContact => {

        let group = MAP_GROUP[oContact.type];
        let name = oContact.contact.firstName + " " + oContact.contact.lastName;
        let phone = "";
        let email = "";

        if (oContact.phone && oContact.phone.length) {
          let primaryPhone = oContact.phone.find(p => p.isPrimary);
          if (primaryPhone) {
            phone = primaryPhone.number;
          }
        }

        if (oContact.email && oContact.email.length) {
          let primaryEmail = oContact.email.find(e => e.isPrimary);
          if (primaryEmail) {
            email = primaryEmail.address;
          }
        }

        oContact.contact.address.forEach(addr => {

          let composedName = name + ", " + addr.street + " (" + addr.type + ")";
          if (addr.isPrimary)
            composedName += " (PRIMARY)";

          pickContactPreselects.push({
            name: composedName,
            group: group,
            payload: {
              name: name,
              address: addr.street,
              address2: addr.street2,
              phone: phone,
              email: email
            }
          });

        })

      });

      var modalInstance = this.$uibModal.open({
        animation: true,
        component: 'reportFilterModal',
        resolve: {
          config: function() {
            return {
              filter: [{type: "pick-contact-preselect"}],
              pickContactPreselects: pickContactPreselects,
              title: "Create and Download Letter",
              report: 'custom-entity-letter',
              entityId: entityId,
              entityName: entityName,
              template: template,
              fileTypes: ['docx','odt','pdf'],
              attach: attach
            }
          }
        },
        size: 'md'
      });

      modalInstance.result.then(
        function () {
          if (attach) {
            that.refreshAttachments();
          }
        },
        function () {
          if (attach) {
            that.refreshAttachments();
          }
        }
      );
    });
  }

  openCustomEntityLetterReportModal(templateId, attach) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'reportFilterModal',
      resolve: {
        config: function() {
          return {
            title: "Create and Download Letter",
            report: 'custom-entity-letter',
            entityId: that.entityId,
            template: templateId,
            fileTypes: ['docx','odt','pdf'],
            attach: attach
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function () {
        if (attach) {
          that.refreshAttachments();
        }
      },
      function () {
        if (attach) {
          that.refreshAttachments();
        }
      }
    );

  }

  refreshAttachments() {
    let count = this.entity.attachments.length;

    /* Nice Code :) */
    this.$timeout(_=> {
      this.refreshData(_=>{
        if (this.entity.attachments.length === count) {
          this.$timeout(_=> {
            this.refreshData(_=>{
              if (this.entity.attachments.length === count) {
                this.$timeout(_=> {
                  this.refreshData(_=>{
                    if (this.entity.attachments.length === count) {
                      this.$timeout(_=> {
                        this.refreshData();
                      }, 10000);
                    }
                  });
                }, 5000);
              }
            });
          }, 2500);
        }
      });
    }, 2500);
  };

  getSectionClass(section) {
    if (!this.view.sectionStyle || !this.view.sectionStyle[section] || !this.view.sectionStyle[section].class)
      return "col-xs-12";

    return this.view.sectionStyle[section].class;
  }

  getSectionTemplate(section) {
    if (!this.view.sectionTemplate || !this.view.sectionTemplate[section])
      return null;

    return this.view.sectionTemplate[section];
  }

  pluralize(word) {
    return pluralize(word, 2);
  }

  refreshData() {
    if (this.entityId) {
      this.CustomEntityService.get({id: this.entityId}, data => {
        this.entity = data;

        this.RecentVisits.addCustomPortfolio(this.entityId, "custom", this.type, this.entity.data[this.view.titleData] + " (" + this.capitalize(this.dehyphendType) + ")");
        this.isPinned = this.PinnedItems.isPinnedPortfolio(this.entityId);
      }, err => {
        console.log('Could not load custom entity from server');
      });
    }
  }

  getSelectedOrFirstAttachmentImage(selected) {

    if (selected) {
      return "/api/storage/" + selected;
    }

    let images = this.entity.attachments.filter(att => att.contentType.startsWith("image"));

    if (images.length) {
      return "/api/storage/" + images[0]._id;
    }
  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.CustomEntityService.addAttachments({id: that.entityId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to entity');
        });
      },
      function () { }
    );

  }
}

export default angular.module('conduu.customShow', [uiRouter])
  .config(routes)
  .component('customShow', {
    template: require('./custom-show.html'),
    controller: CustomShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/custom/show/custom-show.component.js